import React, { useCallback, useState, useEffect } from "react";

import { Link, useNavigate } from 'react-router-dom';
import Chevron from './../images/chevron.png';

import './success-failure.scss';
import Spinner from './../components/spinner';


const Failure = ({ completedTestExists, loading, user }) => {

  
  return (
    <div className="success-body">
    
                {(loading == true) ?
                    <Spinner />
                    :
                    <>
                        {(!user) ? <> User not logged in </> :
                            <>
                                <h1> Failure </h1>
                                There was a problem processing your payment. 
                               
                               <div>
                                <Link to="/">
                                        <button className="button" >
                                            <div className="button-text" >  Return home </div>
                                            <img className="button-icon" src={Chevron} alt="chevron" />
                                        </button>
                                    </Link>
                               </div>
    
                            </>
                        }
    
                    </>
    
                }
            </div >



  );

}
  
  


export default Failure;
